<template>
  <div class="button-thumb">
    <span class="base-sprite sprite-images image-picture-icon" v-if="isLoading"/>
    <div
      class="button-thumb-loaded"
      :class="getCompleted"
      :style="getImage"
      @click="onThumbClicked"
      @mouseover="isHover = true"
      @mouseout="isHover=false"
    >
      <div class="thumb-user-info">
        <span
          class="thumb-user-label"
          @click.prevent.stop="openLink(image)"
          unselectable="on"
        >{{image.user.name}} ({{image.provider}})</span>
        <sw-button
          class="thumb-user-link"
          icon="search"
          font="fa"
          @click.native.prevent.stop="openImage(image)"
        />
      </div>
      <div class="thumb-loading flex center full" v-if="isClicked">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="24px"
          height="30px"
          viewBox="0 0 24 30"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
        >
          <rect x="0" y="0" width="4" height="20" fill="#333">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="1; .2; 1"
              begin="0s"
              dur="0.6s"
              repeatCount="indefinite"
            ></animate>
          </rect>
          <rect x="7" y="0" width="4" height="20" fill="#333">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="1; .2; 1"
              begin="0.2s"
              dur="0.6s"
              repeatCount="indefinite"
            ></animate>
          </rect>
          <rect x="14" y="0" width="4" height="20" fill="#333">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="1; .2; 1"
              begin="0.4s"
              dur="0.6s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'imagethumb',
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    let img = new Image()
    img.onload = () => {
      this.isLoading = false
    }
    img.src = this.image.image.thumb
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      isLoading: true,
      isHover: false,
      isClicked: false
    }
  },
  props: {
    image: Object
  },
  computed: {
    getImage() {
      return !this.isLoading ? `background-image:url(${this.image.image.thumb})` : ''
    },
    getCompleted() {
      return !this.isLoading ? 'button-thumb-loaded-complete' : ''
    }
  },
  methods: {
    openLink(item) {
      window.open(item.copyright, '_blank')
    },
    openImage(item) {
      let uri = ''
      if (item.provider === 'unsplash') {
        uri = `${item.image.large}?utm_source=Swello+Picture+Editor&utm_medium=referral&utm_campaign=api-credit`
      } else {
        uri = item.image.large
      }
      window.open(uri, '_blank')
    },
    onThumbClicked() {
      this.isClicked = true
      this.$emit('click', { image: this.image, thumb: this })
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/images/ImageThumb.vue